import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../i18n/useTranslation";

const CDN = "https://pub-dd11db53b680447d86c08d43682efe32.r2.dev";

interface SiteFooterProps {
  showAccessibilityLink?: boolean;
  /** Use "full" on the home page for the rich dark footer. */
  variant?: "minimal" | "full";
}

const SiteFooter: React.FC<SiteFooterProps> = ({
  showAccessibilityLink = false,
  variant = "minimal",
}) => {
  const { t } = useTranslation();

  if (variant === "full") {
    return (
      <footer
        className="relative z-10 bg-heading px-6 py-2.5 sm:px-10 sm:py-3
        flex items-center justify-between flex-wrap gap-3 sm:gap-4"
      >
        <Link to="/" className="flex shrink-0 items-center">
          <img
            src={`${CDN}/images/home/logo.png`}
            alt="MySipur"
            className="h-9 w-auto max-w-[min(200px,48vw)] object-contain object-left"
          />
        </Link>
        <nav
          className="flex flex-wrap items-center gap-4 sm:gap-5"
          aria-label={t("a11y.navPrimary")}
        >
          <Link
            to="/terms"
            className="text-xs text-white/45 hover:text-white/80 transition"
          >
            {t("legal.termsTitle")}
          </Link>
          <Link
            to="/privacy"
            className="text-xs text-white/45 hover:text-white/80 transition"
          >
            {t("legal.privacyTitle")}
          </Link>
          <Link
            to="/accessibility"
            className="text-xs text-white/45 hover:text-white/80 transition"
          >
            {t("a11y.statement.title")}
          </Link>
        </nav>
        <p className="shrink-0 text-xs leading-none text-white/30">© 2026 MySipur</p>
      </footer>
    );
  }

  if (!showAccessibilityLink) return null;

  return (
    <footer
      className="relative z-10 border-t border-white/30
      bg-brandBeige/90 py-4 text-center text-sm text-body"
    >
      <Link
        to="/accessibility"
        className="font-semibold text-brandNavy hover:underline
          focus:outline-none focus:ring-2 focus:ring-brandOrange
          focus:ring-offset-2 rounded px-1"
      >
        {t("a11y.footerAccessibility")}
      </Link>
    </footer>
  );
};

export default SiteFooter;
